import { render, staticRenderFns } from "./CompareDates.vue?vue&type=template&id=31a72d3a&scoped=true&"
import script from "./CompareDates.vue?vue&type=script&lang=js&"
export * from "./CompareDates.vue?vue&type=script&lang=js&"
import style0 from "./CompareDates.vue?vue&type=style&index=0&id=31a72d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a72d3a",
  null
  
)

export default component.exports